import React, { useEffect, useState } from "react";
import Corner from "./../corner1";
import { MdTableBar } from "react-icons/md";
import { SiMaterialdesignicons } from "react-icons/si";
import { IoDiamond } from "react-icons/io5";

const CenteredBoxComponent = () => {
  const [animate, setAnimate] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleScroll = () => {
      const element = document.querySelector(".container");
      if (element) {
        const rect = element.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.5) {
          setAnimate(true);
        }
      }
    };

    const handleResize = () => setWindowWidth(window.innerWidth);

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);
    handleScroll();
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Responsive styles dynamically calculated based on screen width
  const getResponsiveStyles = () => {
    if (windowWidth <= 480) {
      return {
        centeredBoxWidth: "90%",
        imageHeight: "400px",
        verticalLineHeight: "190px",
        padding: "10px",
        flexDirection: "column",
        textAlign: "center",
        imageColumnPadding: "0",
      };
    } else if (windowWidth <= 768) {
      return {
        centeredBoxWidth: "75%",
        imageHeight: "400px",
        verticalLineHeight: "150px",
        padding: "20px",
        flexDirection: "row",
        textAlign: "left",
        imageColumnPadding: "50px",
      };
    }
    return {
      centeredBoxWidth: "40%",
      imageHeight: "500px",
      verticalLineHeight: "200px",
      padding: "30px",
      flexDirection: "row",
      textAlign: "left",
      imageColumnPadding: "150px",
    };
  };

  const styles = getResponsiveStyles();

  return (
    <div>
      <div className={`container ${animate ? "slide-in" : ""}`} style={{ width: "100%", position: "relative",marginTop:"100px" }}>
        {/* Background Image */}
        <div style={{ width: "100%", height: styles.imageHeight }}>
          <img
            src="https://img.freepik.com/premium-photo/elegant-living-room-interior_252025-54419.jpg"
            alt="Background"
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        </div>

        {/* Centered Info Box */}
        <div
          style={{
            position: "absolute",
            top: "27%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            background: "white",
            padding: styles.padding,
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            textAlign: "center",
            zIndex: 10,
            width: styles.centeredBoxWidth,
            transition: "all 0.3s ease-in-out",
          }}
        >
          <h2 style={{ fontWeight: "bold", color: "#5c0e14" }}>Interior Design</h2>
          <h3>A Perfect Blend of Aesthetics & Practicality</h3>
          <p>
            We specialize in transforming interiors into stunning yet functional spaces. Our interior designers curate personalized, ergonomic,
            and stylish environments tailored to your needs.
          </p>
        </div>

        {/* Vertical Line (Responsive) */}
        <div
          style={{
            position: "absolute",
            top: "-5%",
            left: "50%",
            transform: "translateX(-50%)",
            width: "2px",
            height: styles.verticalLineHeight,
            background: "#5c0e14",
            zIndex: 20,
          }}
        ></div>

        {/* Two Columns Below the Image */}
        <div style={{ display: "flex", flexWrap: "wrap", flexDirection: styles.flexDirection, marginTop: "50px", padding: styles.padding }}>
          {/* First Column - Added Corner */}
          <div style={{ flex: "1", padding: styles.padding, textAlign: styles.textAlign, position: "relative" }}>
            {/* Top-Right Corner */}
            <div style={{ position: "absolute", top: "0px", right: "0px", width: "50px" }}>
              {/* <Corner /> */}
            </div>

            <h2 style={{ fontWeight: "bold", color: "#5c0e14" }}>Schematic Design</h2>
            <h3 style={{ fontSize: "24px", color: "grey" }}>Concept Design</h3>
            <p>
              Schematic design is where the fun comes in. We prepare a series of design options for each level of your home and work with you to find out what suits you
              best.
            </p>
          </div>

          {/* Image Column */}
          <div style={{ flex: "1", display: "flex", flexDirection: "column", gap: "20px", paddingLeft: styles.imageColumnPadding }}>
            <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
              <SiMaterialdesignicons
                style={{ width: "50px", height: "50px", borderRadius: "8px" }}
              />
              <span>Residential & Commercial Interior Design</span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
              <MdTableBar
                style={{ width: "50px", height: "50px", borderRadius: "8px" }}
              />
              <span>Space Planning & Furniture Selection</span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
              <IoDiamond
                style={{ width: "50px", height: "50px", borderRadius: "8px" }}
              />
              <span>Luxury & Contemporary Styling</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CenteredBoxComponent;
